import { defineStore } from 'pinia';
import type { Country, PrincipalSubdivision } from '@/api';

export const useGeoStore = defineStore('geo', () => {
    const countries = shallowRef<Country[]>([]);
    const subdivisionsByCountry = ref<Record<string, PrincipalSubdivision[]>>({});

    const refreshCountries = async () => {
        try {
            const data = await api.listCountries();
            countries.value = data.data;
        } catch (e) {
            countries.value = [];
            console.error('Failed to refresh countries', e);
        }
    };

    const fetchingSubdivisions: string[] = [];
    const fetchSubdivisions = async (country: string) => {
        if (fetchingSubdivisions.includes(country) || subdivisionsByCountry.value[country] != null) {
            return;
        }
        try {
            fetchingSubdivisions.push(country);
            const data = await api.listPrincipalSubdivisions({ params: { country_code_iso2: country } });
            subdivisionsByCountry.value[country] = data.data;
        } finally {
            fetchingSubdivisions.splice(fetchingSubdivisions.indexOf(country), 1);
        }
    };

    refreshCountries();

    const selectOptions = computed(() => ({
        countries:
            countries.value.map(c => ({
                label: c.name,
                value: c.iso2,
            })) ?? [],
    }));

    const formatCountry = (value: any) => countries.value.find(c => c.iso2 === value)?.name;

    const formatState = (value: any, country?: string) => {
        for (const subdivisions in subdivisionsByCountry.value) {
            for (const subdivision of subdivisionsByCountry.value[subdivisions] ?? []) {
                if (subdivision.subdivision_code === value) {
                    return subdivision.name;
                }
            }
        }
        if (country) {
            fetchSubdivisions(country);
        }
        return value;
    };

    return {
        countries,
        subdivisionsByCountry,
        refreshCountries,
        fetchSubdivisions,
        selectOptions,
        formatCountry,
        formatState,
    };
});
